var _path, _path2, _path3, _rect, _rect2, _rect3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppImage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51 49L51 57L59 57",
    stroke: "#004048",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 15L13 7L5 7",
    stroke: "#004048",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2279 8.12124C11.4891 8.73445 10.7721 9.38727 10.0797 10.0797C-2.02656 22.1859 -2.02656 41.8141 10.0797 53.9203C19.0588 62.8994 32.1757 65.2188 43.2924 60.8785M19.9626 3.42362C31.2338 -1.31948 44.7398 0.899211 53.9203 10.0797C66.0266 22.1859 66.0266 41.8141 53.9203 53.9203C53.1802 54.6604 52.4121 55.3552 51.6192 56.0048",
    stroke: "#004048",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 16.7617,
    width: 24,
    height: 35.2381,
    fill: "#D8D1C0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 12,
    width: 24,
    height: 5,
    fill: "#004048"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 47,
    width: 24,
    height: 5,
    fill: "#004048"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 51C32.8284 51 33.5 50.3284 33.5 49.5C33.5 48.6716 32.8284 48 32 48C31.1716 48 30.5 48.6716 30.5 49.5C30.5 50.3284 31.1716 51 32 51Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppImage);
export default __webpack_public_path__ + "static/media/app_Image.9f2e411be0a5ae730ce77d9dcbdfe995.svg";
export { ForwardRef as ReactComponent };